declare global {
  interface Blob {
    toPNG(): Promise<Blob>;
    toWebP(): Promise<Blob>;
    toJPEG(): Promise<Blob>;
  }
}

if (!Blob.prototype.toPNG) {
  Blob.prototype.toPNG = async function(): Promise<Blob> {
    return BlobImageConvert.convertBlob(this, 'image/png');
  };
}

if (!Blob.prototype.toWebP) {
  Blob.prototype.toWebP = async function(): Promise<Blob> {
    return BlobImageConvert.convertBlob(this, 'image/webp');
  };
}

if (!Blob.prototype.toJPEG) {
  Blob.prototype.toJPEG = async function(): Promise<Blob> {
    return BlobImageConvert.convertBlob(this, 'image/jpeg');
  };
}

export default class BlobImageConvert {

  public static async convertBlob(blob: Blob, type: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const canvas = BlobImageConvert.createTempCanvas() as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      const image = new Image();
      image.src = URL.createObjectURL(blob);
      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx!.drawImage(image, 0, 0);
        const result = BlobImageConvert.dataURItoBlob(canvas.toDataURL(type));
        resolve(result);
      };
    });
  }

  public static dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {type: mimeString});
    return blob;
  }

  public static createTempCanvas(): HTMLCanvasElement {
    const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
    canvas.style.display = 'none';
    return canvas;
  }

}
